/* eslint-disable react/no-did-mount-set-state */
import React from 'react/addons';
import _ from 'underscore';
import classNames from 'classnames';
import { shallowEqual } from 'pure-render-mixin';

import ImgixClient from "ofs/utils/imgix";

function getPixelRatio(context) {
  return (context || window).devicePixelRatio || 1;
}

function getPageOffset() {
  if (Object.prototype.hasOwnProperty.call(window, 'pageYOffset')) {
    return window.pageYOffset;
  }

  return document.documentElement.scrollTop;
}

function getHeightAtWidth(width, ratio) {
  return parseInt(
    Math.round(parseInt(width, 10) / ratio)
  , 10);
}

export function getImgixUrl(imageUrl, width, height, bounds) {
  const imgixClient = new ImgixClient("onefinestay.imgix.net", null, true);

  const [cropLeft, cropTop, cropRight, cropBottom] = bounds;
  const cropWidth = cropRight - cropLeft;
  const cropHeight = cropBottom - cropTop;

  /* eslint-disable comma-spacing */
  const rect = `${cropLeft},${cropTop},${cropWidth},${cropHeight}`;
  /* eslint-enable comma-spacing */

  return imgixClient.path(imageUrl, {
    w: width,
    h: height,
    auto: 'format',
    fit: 'crop',
    rect
  }).toString();
}

let ResponsiveImage = React.createClass({
  propTypes: {
    ratio: React.PropTypes.number.isRequired,
    url: React.PropTypes.string.isRequired,
    bounds: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
    defaultWidth: React.PropTypes.number.isRequired,
    lazyloadOffset: React.PropTypes.number,
    scrollDelay: React.PropTypes.number
  },

  getDefaultProps() {
    return {
      lazyloadOffset: 0,
      scrollDelay: 250
    };
  },

  getInitialState() {
    return {
      visible: false,
      width: null,
      loaded: false,
      src: 'data:image/gif;base64,R0lGODlhEAAJAIAAAP///wAAACH5BAEAAAAALAAAAAAQAAkAAAIKhI+py+0Po5yUFQA7'
    };
  },

  setImage() {
    let {url, ratio, bounds} = this.props;

    let devicePixelRatio = getPixelRatio();

    let el = this.getDOMNode();
    let width = el.clientWidth;

    // generate url
    let height = getHeightAtWidth(width * devicePixelRatio, ratio);
    let src = getImgixUrl(
      url,
      Math.round(width * devicePixelRatio),
      height,
      bounds
    );

    // check if the image is visible
    let visible = this.isVisible();

    this.setState({width, src, visible}, () => {
      if (visible === true) {
        this.loadImage();
      }
    });
  },

  isVisible() {
    // Credit: https://github.com/BBC-News/Imager.js/blob/13b471a10e7b15971e864a1d7f9ab98cd0a495fe/Imager.js#L286-L300
    if (!this.isMounted()) {
      return false;
    }

    var element = this.getDOMNode();

    var elementOffsetTop = 0;
    var offset = getPageOffset() + this.props.lazyloadOffset;

    if (element.offsetParent) {
      /* eslint-disable no-cond-assign */
      do {
        elementOffsetTop += element.offsetTop;
      } while (element = element.offsetParent);
      /* eslint-enable no-cond-assign */
    }

    return elementOffsetTop < (document.documentElement.clientHeight + offset);
  },

  setVisible() {
    if (this.state.visible !== true && this.isVisible()) {
      this.setState({
        visible: true
      }, () => {
        this.loadImage();
      });
    }
  },

  loadImage() {
    if (this.loadingImage) {
      // remove existing loading image
      this.removeLoadingImage();
    }

    // create image node and listen to when the image has finished loaded
    let img = document.createElement('img');
    img.addEventListener('load', this.handleImageLoaded);

    img.src = this.state.src;

    this.loadingImage = img;
  },

  handleImageLoaded() {
    if (this.loadingImage) {
      this.removeLoadingImage();

      this.setState({
        loaded: true
      });
    }
  },

  removeLoadingImage() {
    this.loadingImage.removeEventListener('load', this.handleImageLoaded);
    this.loadingImage.remove();
    this.loadingImage = null;
  },

  onResize() {
    this.setImage();
  },

  onScroll() {
    this.setVisible();
  },

  componentWillMount() {
    this.onResize = _.debounce(this.onResize, 250);
    this.onScroll = _.debounce(this.onScroll, this.props.scrollDelay);
  },

  componentDidMount() {
    // Setup image
    // Wait until next tick to access the dom
    this._timer = setTimeout(() => {
      if (this.isMounted()) {
        this.setImage();
      }
    }, 0);

    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);

    if (this._timer) {
      clearTimeout(this._timer);
    }

    if (this.loadingImage) {
      this.removeLoadingImage();
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    if (!shallowEqual(this.state, nextState)) {
      return true;
    }

    const {bounds: nextBounds, ...otherProps} = nextProps;
    const {bounds, ...props} = this.props;

    if (!shallowEqual(props, otherProps)) {
      return true;
    }

    if (bounds.join() !== nextBounds.join()) {
      return true;
    }

    return false;
  },

  renderFallback() {
    let {url, ratio, bounds, defaultWidth} = this.props;

    // generate url
    let height = getHeightAtWidth(defaultWidth, ratio);
    let src = getImgixUrl(url, defaultWidth, height, bounds);

    // have to set this statically due to https://github.com/facebook/react/issues/1252
    return (
      <noscript dangerouslySetInnerHTML={{
        __html: `<img width=${defaultWidth} src="${src}"></img>`
      }} />
    );
  },

  render() {
    let {ratio} = this.props;
    let {visible, src, width, loaded} = this.state;

    let height = null;
    let containerStyle = {};

    if (width) {
      height = getHeightAtWidth(width, ratio);
      containerStyle = {
        'minHeight': height
      };
    }

    let classes = classNames({
      'ofs-ResponsiveImage': true,
      'ofs-ResponsiveImage--is-visible': visible,
      'ofs-ResponsiveImage--is-loaded': loaded
    });

    return (
      <div className={classes} style={containerStyle}>
        {visible &&
          <img src={src} className='ofs-ResponsiveImage__Image' style={{opacity: loaded ? 100 : 0}} />}

        {this.renderFallback()}
      </div>
    );
  }
});

export default ResponsiveImage;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/ResponsiveImage.jsx
 **/